import Vue from 'vue'
import App from './App'
import router from './router'
import '@vant/touch-emulator'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import './assets/css/common.css'
import './assets/js/site'

import store from './store'//引入Vuex

import FloatTools from './components/FloatTools'
import Goods from './components/Goods'

//import AddressEdit from './components/AddressEdit'

import Site from './assets/js/site.js'

import LuckDraw from 'vue-luck-draw'//大转盘
import preventReClick from "./assets/js/preventReClick";
Vue.use(preventReClick)
// 注册全局方法

import {
  Button,
  Icon,
  Cell, CellGroup,
  Calendar,
  Card,
  Tag,
  Checkbox, CheckboxGroup,
  Radio, RadioGroup,
  Image,
  Lazyload,
  Swipe, SwipeItem,
  NavBar,
  Sticky,
  Grid, GridItem,
  Stepper,
  SubmitBar,
  Dialog,
  Popup,
  Form,
  DropdownMenu, DropdownItem,
  Field,
  ActionSheet,
  List,
  Toast,
  Collapse, CollapseItem,
  Tab, Tabs,
  Switch,
  Rate,
  Uploader,
  Area,
  Picker,
  NoticeBar,
  AddressEdit,
  Search ,
  DatetimePicker
} from 'vant'
import Store from "./store";

Vue.use(Button)
  .use(Cell).use(CellGroup)
  .use(Calendar)
  .use(Icon)
  .use(Checkbox).use(CheckboxGroup)
  .use(Radio).use(RadioGroup)
  .use(Card)
  .use(Tag)
  .use(Image)
  .use(Lazyload)
  .use(Swipe).use(SwipeItem)
  .use(NavBar)
  .use(Sticky)
  .use(Grid).use(GridItem)
  .use(Stepper)
  .use(SubmitBar)
  .use(Dialog)
  .use(Popup)
  .use(Form)
  .use(DropdownMenu).use(DropdownItem)
  .use(Field)
  .use(ActionSheet)
  .use(List)
  .use(Toast)
  .use(Collapse).use(CollapseItem)
  .use(Tab).use(Tabs)
  .use(Switch)
  .use(Uploader)
  .use(Rate)
  .use(Picker)
  .use(Area)
  .use(AddressEdit)
  .use(Search)
  .use(DatetimePicker)
  .use(NoticeBar);

Vue.use(Site);
Vue.use(LuckDraw)
Vue.use(VueAxios, axios);

Vue.use(FloatTools)
  .use(Goods)
  //.use(Goodsframe)
  //.use(modifypriceframe);

//======= 注册自定义组件
Vue.component('FloatTools', FloatTools);
Vue.component('Goods', Goods);
//Vue.component('AddressEdit', AddressEdit);

Vue.prototype.qs = qs;                                    

//======= 路由守卫
router.beforeEach((to, from, next) => {
  const reload_url = window.location.href;
  if(store.state.browser.wx || store.state.browser.wxminiprogram){
    // if((to.name == 'Index' || to.name == 'GoodsView' || to.name == 'StoreSpread' || to.name == 'GoodsSpread' || to.name == 'Order' || to.name == 'MyOrder')){ // SCRM活码来的
      if (Vue.prototype.getQueryStringP('source') || window.location.href.indexOf('&f') > -1 || Vue.prototype.getQueryStringP('qr_id') || Vue.prototype.getQueryStringP('qr_type') || Vue.prototype.getQueryStringP('qr_obj_id')){
            if(Vue.prototype.getQueryStringP('source'))sessionStorage.setItem('source',Vue.prototype.getQueryStringP('source'))
            if(window.location.href.indexOf('&f') > -1)sessionStorage.setItem('source','OFFLINE')
            if (Vue.prototype.getQueryStringP('qr_id')) sessionStorage.setItem('live_code', Vue.prototype.getQueryStringP('qr_id'))
            if (Vue.prototype.getQueryStringP('qr_type')) sessionStorage.setItem('qr_type', Vue.prototype.getQueryStringP('qr_type'))
            if (Vue.prototype.getQueryStringP('qr_obj_id')) sessionStorage.setItem('qr_obj_id', Vue.prototype.getQueryStringP('qr_obj_id'))
            if (Vue.prototype.getQueryStringP('qr_staff_id')) sessionStorage.setItem('qr_staff_id', Vue.prototype.getQueryStringP('qr_staff_id'))
            if (Vue.prototype.getQueryStringP('qr_shopno')) sessionStorage.setItem('qr_shopno', Vue.prototype.getQueryStringP('qr_shopno'))
        }
    // }
  }
  // yxj 2025.11.26 增加SCRM埋点 来源渠道 来源 路径 是否分享
  if (Vue.prototype.getQueryStringP('source_client')) sessionStorage.setItem('source_client', Vue.prototype.getQueryStringP('source_client'))
  if (Vue.prototype.getQueryStringP('scrm_origin')) sessionStorage.setItem('scrm_origin', Vue.prototype.getQueryStringP('scrm_origin'))
  if (Vue.prototype.getQueryStringP('scrm_path')) sessionStorage.setItem('scrm_path', Vue.prototype.getQueryStringP('scrm_path'))
  if (Vue.prototype.getQueryStringP('is_share')) sessionStorage.setItem('is_share', Vue.prototype.getQueryStringP('is_share'))
  const is_login = window.navigator.userAgent.split("isLogin=")[1]
    // 'https://'+window.location.host + '/#' +from.fullPath;
  // 骑行App 游客模式下，清空本地缓存
  if(store.state.browser.giantapp && store.state.browser.tourist && is_login == 0){
    sessionStorage.clear()
    localStorage.clear()
    // console.log('进入游客模式',to.path)
  }
  // 骑行App 游客模式下，跳转登录拦截 使用App的方法
  const userId = store.state.loginUser.id || (localStorage.getItem('giant_userdata') ? JSON.parse(localStorage.getItem('giant_userdata')).id : '' )
  console.log(store.state.browser.giantapp,store.state.browser.tourist,Vue.prototype.checkGiantAppVersion('4.1.2', '4.1.2'),userId,'测试打印')
  //电动车环境中，用某既定页面替代首页
  if( to.path === '/' && store.state.browser.giantevapp ) {
    //router.replace({ path: '/land/' + store.state.giantEvIndexId});
    location.replace('/#/land/' + store.state.giantEvIndexId);
    setTimeout(function(){
      location.reload();
    }, 500);
    return false;
  }

  //路由发生变化修改页面title
  if (to.meta.title) {
    if(to.path === '/') {
      document.title = '捷安特官方商城';
    } else {
      document.title = to.meta.title + ' - 捷安特官方商城';
    }
  }

  //index.html
  let jweixin = document.getElementById("er");
  jweixin.src = ""+store.state.externalurl.GIANT_CDN+"/js/jweixin-1.6.0.js";

  let linkStyle = document.getElementsByTagName("link");
  linkStyle[0].href = ""+store.state.externalurl.GIANT_CDN+"/css/style.css";

  //分享信息
  let metaList = document.getElementsByTagName('meta');
  for (var i = 0; i < metaList.length; i++) {
    if (metaList[i].getAttribute("name") == "shareImg") {
      metaList[i].content = ""+store.state.externalurl.GIANT_CDN+"/img/share_logo.png";
    }
    if (metaList[i].getAttribute("name") == "shareTitle") {
      metaList[i].content = document.title;
    }
    if (metaList[i].getAttribute("name") == "shareDesc") {
      metaList[i].content = '捷安特官方商城是捷安特公司精心为用户打造的自行车购物及服务平台';//document.title;
    }
    if (metaList[i].getAttribute("name") == "shareLink") {
      let tmpMeta = metaList[i];
      setTimeout(function(){
        tmpMeta.content = location.href;
      }, 100);
    }
  }


  //获取到已登录的用户信息
  let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata')) || Store.state.loginUser;

  if( loginuser_data && loginuser_data.sessionkey ){
    store.commit('updateLoginUser', loginuser_data);
  } else {
    //判断当前页是否需要登录
    if( to.meta.requireLogin ){
      //console.log(location.href);
      router.replace({ path: '/login', query: { redirect: location.href }});
      //router.replace({ path: '/login', query: { redirect: to.fullPath }});
      //router.push({ path: '/login', query: { redirect: to.fullPath }});
    }
  }
  if(is_login == 0 && store.state.browser.giantapp && store.state.browser.tourist && Vue.prototype.checkGiantAppVersion('4.1.2', '4.1.2') && to.path == '/login' && (!userId)){
    if(store.state.browser.ios){
      window.webkit.messageHandlers.jumpLoginView.postMessage(JSON.stringify({reload_url: reload_url}));
    }else{
      // window.android.jumpLoginView.postMessage(JSON.stringify({reload_url: reload_url}));//返回首页
    }
    next(false);
    return false;
  }else{
    next();
  }
});

Vue.config.productionTip = false;

const _Vue = new Vue({
  router,
  store,
  components: { App },
  render: h => h(App),
}).$mount("#app");

export default _Vue;



// WEBPACK FOOTER //
// ./src/main.js